import request from '@/utils/request'

// 查询商铺列表
export function queryShopsByAdmin(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopsByAdmin',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询打印设备列表
export function listShopPrinterMachine(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/printerMachine.listShopPrinterMachine',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加打印设备
export function saveShopPrinterMachine(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/printerMachine.saveShopPrinterMachine',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新打印设备
export function updateShopPrinterMachine(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/printerMachine.updateShopPrinterMachine',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除打印设备
export function deleteShopPrinterMachine(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/printerMachine.deleteShopPrinterMachine',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}